import { compose } from "recompose";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import Sale from "../../../../../../../../utilities/data/model/Sale";
import { of } from "@nozbe/watermelondb/utils/rx";
import { Colors, View } from "react-native-ui-lib";
import { Text } from "@towersystems/roam-common-native";
import { moneyToFormattedString } from "../../../../../../../../utilities/money";

const getObserables = ({ sale }: { sale: Sale }) => ({
  loyaltyValue: sale?.maxDiscountGivenLoyaltyPoints || of(null),
});

interface LoyaltyValueRendererProps
  extends ExtractedObservables<ReturnType<typeof getObserables>> {}

const LoyaltyValueRenderer = ({ loyaltyValue }: LoyaltyValueRendererProps) => {
  const normalizedLoyaltyValue = moneyToFormattedString(
    Number(loyaltyValue) || 0
  );

  if (!loyaltyValue) {
    return null;
  }

  return (
    <View>
      <Text
        style={{
          color: Colors.quickKeyModiferText,
          fontSize: 15,
        }}
      >
        {`Apply ${normalizedLoyaltyValue} Discount`}
      </Text>
    </View>
  );
};

export const LoyaltyValue = withObservables(
  ["sale"],
  getObserables
)(LoyaltyValueRenderer);
